/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleLeftUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABCUlEQVR4nO2TQUoDQRBF27XElQYPoAfwAK40MOjUr4rQVoXkKLrPFQy5QU6QVUQ3utQInkFBN7pXehwFB5yxwd7IPOjdp153V5Vz/5bM+w0SW0BsmqQ42JYQewuSPy9OorehOFjvD7zfbIsXEOt18S21R1/DtxHrBDjedzGQ6FWzwL4f1vPDo8H2rwR5PliH6E1507t+f9StZnq90SpgOxA7IdaHMvvMrLvxErZlmKifsgA6JDorRpntichvRUvCuNZJnHMrX5KYfam8ZF6XzbLhGtgeQzZn3YuTsM0hNm7KEutp2fgzlwJ8NL7Y/EQCdMpmvyQRBD53w6UCraAJsF6S2EVjsMVVeAfAhrXFw9J46gAAAABJRU5ErkJggg==)
 */
export const ArrowAngleLeftUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.3 7.3a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L5.42 9H11a7 7 0 0 1 7 7v4a1 1 0 1 0 2 0v-4a9 9 0 0 0-9-9H5.41l3.3-3.3a1 1 0 0 0-1.42-1.4l-5 5Z"
        className={colorClass}
      />
    </svg>
  );
};
